import {useQuery} from '@tanstack/react-query';
import {SomeCountryCode} from '~/entities/countries';
import {ServiceProviderSchema, useUserInfoQueryOptions} from '~/entities/user';
import {UserInfoEntityType} from '~/entities/user/api/fetchUserInfo';

export function useUserInfoResource() {
    return useQuery({
        ...useUserInfoQueryOptions(),
        select: (data): {user: UserInfoResource} => {
            const {address, personal} = data.dossier!;
            return {
                user: {
                    countryCode: address.countryCode,
                    city: address.city,
                    address: address.streetAddress,
                    email: data.verifiedEmail ?? data.email,
                    fullName: `${personal.givenName ?? ''} ${personal.familyName ?? ''}`,
                    type: data.entityType,
                    serviceProviders: data.serviceProviders,
                    birthdate: personal.birthdate,
                },
            };
        },
    });
}

export type UserInfoResource = {
    fullName: string;
    email: string;
    countryCode: SomeCountryCode;
    city: string;
    address: string;
    type: UserInfoEntityType;
    serviceProviders: ServiceProviderSchema[];
    birthdate: null | Date;
};
